const data = [
  ["Follow", "People Around the Globe"],
  ["Connect", "With Your Friends"],
  ["Share", "What Your Thinking"],
];

export { data };
